import CollectPointsContent from "./CollectPointsContent";

export default CollectPointsContent;
